// TEMPORARY: Font testing controller
// Remove this file when done testing fonts
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "label"]

  fonts = [
    { name: "Inter", value: "'Inter', sans-serif" },
    { name: "Roboto", value: "'Roboto', sans-serif" },
    { name: "IBM Plex Sans", value: "'IBM Plex Sans', sans-serif" },
    { name: "Work Sans", value: "'Work Sans', sans-serif" },
    { name: "Open Sans", value: "'Open Sans', sans-serif" },
    { name: "Public Sans", value: "'Public Sans', sans-serif" },
    { name: "Manrope", value: "'Manrope', sans-serif" },
    { name: "Mulish", value: "'Mulish', sans-serif" },
    { name: "DM Sans", value: "'DM Sans', sans-serif" },
    { name: "SF Pro (Mac)", value: "-apple-system, BlinkMacSystemFont, sans-serif" },
    { name: "Helvetica Neue", value: "'Helvetica Neue', Helvetica, sans-serif" },
    { name: "Verdana (original)", value: "verdana, arial, helvetica, sans-serif" },
  ]

  connect() {
    // Load saved font from localStorage
    const savedFont = localStorage.getItem('testFont')
    if (savedFont) {
      document.documentElement.style.setProperty('--app-font', savedFont)
      if (this.hasSelectTarget) {
        this.selectTarget.value = savedFont
      }
      this.updateLabel(savedFont)
    }
  }

  change(event) {
    const fontValue = event.target.value
    document.documentElement.style.setProperty('--app-font', fontValue)
    localStorage.setItem('testFont', fontValue)
    this.updateLabel(fontValue)
  }

  updateLabel(fontValue) {
    if (this.hasLabelTarget) {
      const font = this.fonts.find(f => f.value === fontValue)
      this.labelTarget.textContent = font ? font.name : 'Unknown'
    }
  }
}
